const React = require("react");

function LoaderIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    role: "img",
    fill: "currentColor",
    className: "anticon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M320 96c0 17.7-14.3 32-32 32s-32-14.3-32-32V32c0-17.67 14.3-32 32-32s32 14.33 32 32v64zm0 384c0 17.7-14.3 32-32 32s-32-14.3-32-32v-64c0-17.7 14.3-32 32-32s32 14.3 32 32v64zM32 256c0-17.7 14.33-32 32-32h64c17.7 0 32 14.3 32 32s-14.3 32-32 32H64c-17.67 0-32-14.3-32-32zm480-32c17.7 0 32 14.3 32 32s-14.3 32-32 32h-64c-17.7 0-32-14.3-32-32s14.3-32 32-32h64zM106.1 74.98c13.4-12.49 33.6-12.49 46.1 0l45.3 45.22c11.6 12.5 11.6 31.9 0 45.3-13.4 11.6-32.8 11.6-45.3 0l-46.1-45.3c-11.62-12.5-11.62-32.72 0-45.22zM469 391.8c12.5 12.5 12.5 32.7 0 45.2s-32.7 12.5-45.2 0l-45.3-45.2c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l45.2 45.3zM106.1 437c-11.62-12.5-11.62-32.7 0-45.2l46.1-45.3c12.5-12.5 31.9-12.5 45.3 0 11.6 12.5 11.6 32.8 0 45.3L152.2 437c-12.5 12.5-32.7 12.5-46.1 0zM423.8 74.98c12.5-12.5 32.7-12.5 45.2 0 12.5 12.49 12.5 32.72 0 45.22l-45.2 45.3c-12.5 11.6-32.8 11.6-45.3 0-12.5-13.4-12.5-32.8 0-45.3l45.3-45.22z"
  }));
}

const ForwardRef = React.forwardRef(LoaderIcon);
module.exports = ForwardRef;